import Handlebars from 'handlebars/runtime';
import { Collapse } from 'bootstrap';
import SlimSelect from 'slim-select';
import ComparisonHelper from './helpers/comparison-helper';

import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'whatwg-fetch';
import 'parsleyjs';
import 'slick-carousel';
import 'jquery-doubletaptogo';
import 'jquery-ui/ui/widgets/autocomplete';
import 'jquery-lazy';
import 'focus-visible';
import './components/jquery.cookie';

// components/views
import './components/mobile-nav';
import './components/mega-nav';
import PeekabooSlider from './views/slideshow-peekaboo';
import './components/search';
import Alerts from './components/alerts';
import SearchUI from './components/search-ui';

// Register handlebars partials
import moduleTable from './templates/layouts/module_table.hbs';
import moduleWYSIWYG from './templates/layouts/module_wysiwyg.hbs';
import moduleFootnotes from './templates/layouts/module_footnotes.hbs';
import moduleList from './templates/layouts/module_list.hbs';
import moduleTestimonials from './templates/layouts/module_testimonials.hbs';
import moduleTile from './templates/layouts/module_tile.hbs';
import moduleVideo from './templates/layouts/module_video.hbs';
import moduleSeparator from './templates/layouts/module_separator.hbs';

// Register handlebars helpers
Handlebars.registerHelper('ifEquals', ComparisonHelper.ifEquals);

Handlebars.registerHelper('substring', (string, start, end) => {
    let theString = string.substring(start, end);
    // attach dot dot dot if string greater than suggested end point
    if (string.length > end) {
        theString += '[...]';
    }
    return new Handlebars.SafeString(theString);
});
Handlebars.registerPartial('module_table', moduleTable);
Handlebars.registerPartial('module_wysiwyg', moduleWYSIWYG);
Handlebars.registerPartial('module_footnotes', moduleFootnotes);
Handlebars.registerPartial('module_list', moduleList);
Handlebars.registerPartial('module_testimonials', moduleTestimonials);
Handlebars.registerPartial('module_tile', moduleTile);
Handlebars.registerPartial('module_video', moduleVideo);
Handlebars.registerPartial('module_separator', moduleSeparator);

// /////////////////////////////////////////////////////////////////////////////
// Routes
// /////////////////////////////////////////////////////////////////////////////

new Alerts();
new SearchUI();

const $body = $('body');
if ($body.hasClass('single-cp_product')) {
    //new ProductDetail();
    const { default: ProductDetail } = await import(
        /* webpackChunkName: "product-detail" */
        './pages/product-detail'
    );
    const productDetail = new ProductDetail();
} else if (
    window.location.pathname === '/resource-center/' ||
    window.location.pathname === '/fr/centre-de-ressources/' ||
    window.location.pathname === '/fr/centre-de-ressources/cats/' ||
    window.location.pathname.indexOf('/resource-center/cats/') === 0
) {
    //new ResourceArchive();
    const { default: ResourceArchive } = await import(
        /* webpackChunkName: "resource-archive" */
        './pages/resource-archive'
    );
    const resourceArchive = new ResourceArchive();
} else if (window.location.pathname === '/products/' || window.location.pathname === '/produits/') {
    //new ProductArchive();
    const { default: ProductArchive } = await import(
        /* webpackChunkName: "product-archive" */
        './pages/product-archive'
    );
    const productArchive = new ProductArchive();
} else if (window.location.pathname === '/sds/' || window.location.pathname === '/fr/fiche-de-donnees-de-securite/') {
    //new ProductArchive(); // shared code with products page
    //new SDSPage();
    const { default: ProductArchive } = await import(
        /* webpackChunkName: "product-archive" */
        './pages/product-archive'
    );
    const productArchive = new ProductArchive();

    const { default: SDSPage } = await import(
        /* webpackChunkName: "page-sds" */
        './pages/page-sds'
    );
    const sdsPage = new SDSPage();
} else if (window.location.pathname === '/blog/' || window.location.pathname === '/fr/blog/') {
    const { default: BlogArchive } = await import(
        /* webpackChunkName: "blog-archive" */
        './pages/blog-archive'
    );
    const blogArchive = new BlogArchive();
} else if (window.location.pathname.indexOf('/blog/') === 0) {
    const { default: BlogArticle } = await import(
        /* webpackChunkName: "blog-article" */
        './pages/blog-article'
    );
    const blogArticle = new BlogArticle();

    const { default: VoteHelpful } = await import(
        /* webpackChunkName: "vote-helpful" */
        './components/vote-helpful'
    );
    const voteHelpful = new VoteHelpful();
} else if (window.location.pathname === '/profile-update/') {
    const { default: ProfileUpdate } = await import(
        /* webpackChunkName: "profile-update" */
        './pages/profile-update'
    );
    const profileUpdate = new ProfileUpdate();
} else if (window.location.pathname === '/order-a-sample/') {
    const { default: SampleForm } = await import(
        /* webpackChunkName: "request-sample" */
        './forms/request-sample'
    );
    const sampleForm = new SampleForm();
} else if ($body.hasClass('search-results')) {
    //new SearchResults();
    const { default: SearchResults } = await import(
        /* webpackChunkName: "search-results" */
        './pages/search-results'
    );
    const searchResults = new SearchResults();
}

// /////////////////////////////////////////////////////////////////////////////
// Modules
// /////////////////////////////////////////////////////////////////////////////

// https://webpack.js.org/guides/lazy-loading/

// found on blog detail pages
if ($('.pw-widget').length) {
    import(
        /* webpackChunkName: "social-widget" */
        './components/social-widget'
    ).then((module) => {
        const SocialWidget = module.default;
        SocialWidget;
        window.social = new SocialWidget();
    });

    // set up share buttons
    document.querySelectorAll('.pw-button-linkedin').forEach((el) => {
        el.addEventListener('click', () => {
            window.social.newWindow(
                `http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(document.URL)}&title=${encodeURIComponent(document.title)}`
            );
        });
    });

    document.querySelectorAll('.pw-button-facebook').forEach((el) => {
        el.addEventListener('click', () => {
            window.social.newWindow(
                `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(document.URL)}&quote=${encodeURIComponent(document.title)}`
            );
        });
    });

    document.querySelectorAll('.pw-button-x').forEach((el) => {
        el.addEventListener('click', () => {
            window.social.newWindow(
                `https://x.com/intent/tweet?text=${encodeURIComponent(document.title)}:%20${encodeURIComponent(document.URL)}`
            );
        });
    });
}

if ($('.quicklinks-menu').length) {
    const { default: QuickLinks } = await import(
        /* webpackChunkName: "quick-links" */
        './views/panel-quicklinks'
    );
    const quickLinks = new QuickLinks();
}

if ($('.accordion-to-tab').length) {
    const { default: PanelResources } = await import(
        /* webpackChunkName: "panel-resources" */
        './views/panel-resources'
    );
    const panelResources = new PanelResources();
}

if ($('.js-view-switcher').length) {
    const { default: ViewSwitcher } = await import(
        /* webpackChunkName: "view-switcher" */
        './components/view-switcher'
    );
    const viewSwitcher = new ViewSwitcher();
}

if ($('.js-image-over-video').length) {
    const { default: ImageOverVideo } = await import(
        /* webpackChunkName: "image-over-video" */
        './components/image-over-video'
    );
    const imageOverVideo = new ImageOverVideo();
}

if ($('.slim-select').length) {
    const { default: SlimSelectModule } = await import(
        /* webpackChunkName: "slim-select" */
        './forms/slimselect-parsley-integration'
    );
    const slimSelectModule = new SlimSelectModule();

    $('select.slim-select').each((i, el) => {
        new SlimSelect({
            select: el,
            showSearch: false,
            placeholder: $(el).find('[data-placeholder="true"]').text(),
        });
    });
}

// //////////////////////////////////////////////////////////////////////////////
// Sticky navigation
// //////////////////////////////////////////////////////////////////////////////
if ($('.header-global .sticky-wrapper').length > 0) {
    const { default: StickyNav } = await import(
        /* webpackChunkName: "sticky-nav" */
        './components/sticky-nav'
    );
    const stickyNav = new StickyNav();
}

// //////////////////////////////////////////////////////////////////////////////
// Init Slideshows
// //////////////////////////////////////////////////////////////////////////////

$('.slick-slider.slider--peekaboo').each((i, el) => {
    new PeekabooSlider(el);
});

// //////////////////////////////////////////////////////////////////////////////
// Common Functions
// //////////////////////////////////////////////////////////////////////////////
$('.js-scroll-to-top').click((e) => {
    e.preventDefault();
    $('html, body').animate({ scrollTop: 0 });
});

$('nav').on('click', '.js-close', (e) => {
    e.preventDefault();
    const $el = $(e.currentTarget);
    const $container = $el.closest('nav');
    $container.removeClass('active');
});

// general lazy loading
window.lazyOptions = {
    scrollDirection: 'vertical',
    effect: 'fadeIn',
    effectTime: 200,
    threshold: 200,
    visibleOnly: true,
    onError(element) {
        console.log(`error loading ${element.data('src')}`);
    },
    // afterLoad: function(element) {
    // called after an element was successfully handled
    // console.log('Lazy loaded: '+ $(element).attr('src'));
    // },
};

$(() => {
    $('.lazy').Lazy(window.lazyOptions);
});

// accordions
$('.accordion-item h2').each(function () {
    const $content = $(this).closest('.accordion-item').find('.accordion-content');
    $(this).click(function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $content.not(':animated').slideToggle();
    });
});

// return should open it and close accordion
$('.accordion-item h2').keypress(function (e) {
    const $content = $(this).closest('.accordion-item').find('.accordion-content');
    if (e.which === 13) {
        $(this).toggleClass('active');
        $content.not(':animated').slideToggle();
    }
});

// on recource center pages /resource-center/2019-novel-coronavirus-2019-ncov/
// section 8 goes to 2
// 2 goes to 3
$(document).ready(() => {
    const urlRC = window.location.pathname;
    if (
        urlRC === '/resource-center/sars-cov-2-the-cause-of-covid-19/' ||
        urlRC === '/resource-center/2019-novel-coronavirus-2019-ncov/'
    ) {
        const urlPart = window.location.hash.substr(1);
        if (urlPart === 'section-8') {
            document.location.hash = 'section-2';
        } else if (urlPart === 'section-2') {
            document.location.hash = 'section-3';
        }
    }
});

// //////////////////////////////////////////////////////////////////////////////
// Forms
// //////////////////////////////////////////////////////////////////////////////

// Overlabel style toggle
$('body').on('focus', '.overlabel', (e) => {
    const $el = $(e.currentTarget);
    // console.log('input focus');
    $el.addClass('active');
});
$('body').on('blur', '.overlabel', (e) => {
    const $el = $(e.currentTarget);
    const $field = $el.find('input');
    // console.log('input blur');
    if ($.trim($field.val()) === '') {
        $field.val('');
        $el.removeClass('active');
    } else {
        $el.addClass('active');
    }
});
$('.overlabel').each((i, el) => {
    const $el = $(el);
    if ($.trim($el.find('input').val()) !== '') {
        $el.addClass('active');
    }
});

// //////////////////////////////////////////////////////////////////////////////
// Responsive Tables
// //////////////////////////////////////////////////////////////////////////////
if (document.querySelector('.breaking-table')) {
    const { default: ResponsiveTables } = await import(
        /* webpackChunkName: "responsive-tables" */
        './components/breaking-tables'
    );
    const responsiveTables = new ResponsiveTables();
}

// //////////////////////////////////////////////////////////////////////////////
// Smoothly scroll to target element
// //////////////////////////////////////////////////////////////////////////////
if (document.querySelector('.js-content-nav') && document.querySelector('#content-nav')) {
    const { default: ContentScroll } = await import(
        /* webpackChunkName: "content-scroll" */
        './components/content-nav-scroll'
    );
    const contentScroll = new ContentScroll();
}
/** *****************************************************************************
 /* document ready
 /***************************************************************************** */
jQuery(document).ready(() => {});

// //////////////////////////////////////////////////////////////////////////////
// Forms - handle Other Role Type & Other Facility
// //////////////////////////////////////////////////////////////////////////////

$('#role_type').on('change', function () {
    if (this.value === 'Other') {
        $('#form-group-role').addClass('form-subcolumns');
        $('#form-group-role-other').show();
        $('#form-group-role-other').addClass('required');
        $('#form-group-role-other input').prop('required', true);
    } else {
        $('#form-group-role').removeClass('form-subcolumns');
        $('#form-group-role-other').hide();
        $('#form-group-role-other').removeClass('required');
        $('#form-group-role-other input').prop('required', false);
    }
});

$('#facility_type').on('change', function () {
    if (this.value === 'Other') {
        $('#form-group-facility').addClass('form-subcolumns');
        $('#form-group-facility-other').show();
        $('#form-group-facility-other').addClass('required');
        $('#form-group-facility-other input').prop('required', true);
    } else {
        $('#form-group-facility').removeClass('form-subcolumns');
        $('#form-group-facility-other').hide();
        $('#form-group-facility-other').removeClass('required');
        $('#form-group-facility-other input').prop('required', false);
    }
});
